import React from 'react';
import { TestimonialCard } from '../components/TestimonialCard';
import { FooterCTA } from '../components/FooterCTA';
import { testimonials } from '../components/testimonials';
export function Testimonials() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-1153">
      {/* HERO */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-20 md:py-32 text-center" data-id="element-1154">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-1155"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1D4ED8] opacity-10 blur-[150px] rounded-full pointer-events-none" data-id="element-1156"></div>
        <div className="max-w-[900px] mx-auto px-5 md:px-12 relative z-10" data-id="element-1157">
          <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-6" data-id="element-1158">
            Povești de Succes
          </h1>
          <p className="font-['Inter'] text-[20px] md:text-[24px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6] max-w-[700px] mx-auto" data-id="element-1159">
            Descoperă cum PROVI System a transformat companiile antreprenorilor
            cu care am lucrat. De la haos operațional, la sisteme care
            funcționează independent de fondator.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS GRID */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1160">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-1161">
          <div className="grid md:grid-cols-3 gap-8" data-id="element-1162">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-1163" />)}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <FooterCTA data-id="element-1164" />
    </div>;
}